import React from "react";
import RealEstateCalculator from "./RealEstateCalculator";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <RealEstateCalculator />
      <Footer /> 
    </div>
  );
}

export default App;
